import { createSlice } from "@reduxjs/toolkit";

const samparkTelecallersSlice = createSlice({
  name: "samparkTelecallers",
  initialState: {
    loading: false,
    mappingList: [],
    agentsList: [],
    existingMappings: [],
    agentDetails: null,
    listCount: 0,
    params: {
      page: 1,
      page_size: 10,
      search: "",
    },
  },
  reducers: {
    getMappingList: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    getMappingListSuccess: (state, action) => {
      return {
        ...state,
        loading: false,
        mappingList: action.payload.results || [],
        listCount: action.payload.count || 0,
      };
    },
    getAgentsList: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    getAgentsListSuccess: (state, action) => {
      return {
        ...state,
        loading: false,
        agentsList: action.payload.results || action.payload || [],
      };
    },
    getExistingMappings: (state) => {
      return {
        ...state,
      };
    },
    getExistingMappingsSuccess: (state, action) => {
      return {
        ...state,
        existingMappings: action.payload.results || action.payload || [],
      };
    },
    getAgentById: (state) => {
      return {
        ...state,
        loading: true,
        agentDetails: null,
      };
    },
    getAgentByIdSuccess: (state, action) => {
      return {
        ...state,
        loading: false,
        agentDetails: action.payload,
      };
    },
    saveMappingData: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    saveMappingSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    createTelecaller: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    createTelecallerSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    updateTelecaller: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    updateTelecallerSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    deleteTelecaller: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    deleteTelecallerSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    deleteMapping: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    deleteMappingSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    updateMappingStatus: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    updateMappingStatusSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    updateTelecallerStatus: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    updateTelecallerStatusSuccess: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    setParams: (state, action) => {
      return {
        ...state,
        params: action.payload,
      };
    },
    apiError: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export const {
  getMappingList,
  getMappingListSuccess,
  getAgentsList,
  getAgentsListSuccess,
  getExistingMappings,
  getExistingMappingsSuccess,
  getAgentById,
  getAgentByIdSuccess,
  saveMappingData,
  saveMappingSuccess,
  createTelecaller,
  createTelecallerSuccess,
  updateTelecaller,
  updateTelecallerSuccess,
  deleteTelecaller,
  deleteTelecallerSuccess,
  deleteMapping,
  deleteMappingSuccess,
  updateMappingStatus,
  updateMappingStatusSuccess,
  setParams,
  apiError,
} = samparkTelecallersSlice.actions;

export default samparkTelecallersSlice.reducer;
